import React, {Dispatch} from "react"
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux"
import Modal from "../Modal"
import {useFormik} from "formik"
import {medicalSlice} from "../../../../store/slices/medicalSlice"
import Input from "../../../generic/dataEntry/Input/Input"
import {
  addMedicalInstitution,
  fetchMedicalInstitutions,
  setCurrentPage,
  updateMedicalInstitution
} from "../../../../store/actions/medicalActions"
import {IMedicalInstitution} from "../../../../models/medical"
import Textarea from "../../../generic/dataEntry/Textarea"
import Checkbox from "../../../generic/dataEntry/Checkbox"
import classes from "../Modal/Modal.module.scss"

interface IAddMedicalInstitutionModalProps {
  close: any
  children?: string | JSX.Element | JSX.Element[]
  editSuccess: Dispatch<any>
  editableItem?: IMedicalInstitution
}

function ModalEditMedicalInstitution({close, editSuccess, editableItem}: IAddMedicalInstitutionModalProps) {

  const dispatch = useAppDispatch()
  const {error, pageSize, isAdding, isUpdating, currentPage} = useAppSelector(state => state.medical)
  const modalTitle = editableItem ? "Редактировать адрес" : "Добавить адрес"

  const initialFormValues =
    editableItem ? {
      medical_uuid: editableItem.medical_uuid,
      medical_name: editableItem.medical_name,
      city: editableItem.city,
      address: editableItem.address,
      entrance: editableItem.entrance,
      floor: editableItem.floor,
      flat: editableItem.flat,
      lift: editableItem.lift
    } : {
      medical_name: "",
      city: "",
      address: "",
      entrance: "",
      floor: "",
      flat: "",
      lift: false
    }

  const {values, touched, handleChange, handleReset} = useFormik({
    initialValues: initialFormValues,
    onSubmit: () => {
    }
  })

  const saveHandler = async () => {
    const medicalID = await dispatch(addMedicalInstitution(values))

    if (medicalID) {
      await dispatch(setCurrentPage(1))
      await dispatch(fetchMedicalInstitutions({page: 1, pageSize}))
      close()
      editSuccess(true)
      handleReset(initialFormValues)
    }
  }

  const updateHandler = async () => {
    const isUpdated = await dispatch(updateMedicalInstitution(values))

    if (isUpdated) {
      editSuccess(true)
      await dispatch(setCurrentPage(1))
      await dispatch(fetchMedicalInstitutions({page: 1, pageSize}))
      close()
      handleReset(initialFormValues)
    }
  }

  const handleFieldChange = (e: React.ChangeEvent) => {
    handleChange(e)
    const fieldName: any = e.target.getAttribute('name')

    if (error[fieldName]) {
      dispatch(medicalSlice.actions.clearFieldError(fieldName))
    }
  }

  const closeHandler = () => {
    close()
    dispatch(medicalSlice.actions.clearAllErrors())
  }

  const commonErrorMessage = Object.keys(error).length > 0 && <div className={classes.form_common_error}>* Не заполнены обязательные поля</div>

  return (
    <Modal
      title={modalTitle}
      close={closeHandler}
      dialogSizeSuffix={"w620"}
      submitClick={editableItem ? updateHandler : saveHandler}
      cancelClick={closeHandler}
      submitDisabled={isUpdating || isAdding}
      submitLoading={isUpdating || isAdding}
    >
      <form
        className={classes.form}
      >
        <div className={classes.form_group}>
          <div className={classes.form_field}>
            <Textarea
              name={"medical_name"}
              label={"Наименование"}
              value={values.medical_name}
              onChange={(e: React.ChangeEvent) => {
                handleFieldChange(e)
              }}
              valid={!error.medical_name}
              errorMessage={error.medical_name}
              touched={touched.medical_name}
              required
              shouldValidate
              rows={4}
            />
          </div>
          <div className={[classes.form_group_container, classes.form_group_container_address].join(" ")}>
            <div className={classes.form_field}>
              <Input
                value={values.city}
                onChange={(e: React.ChangeEvent) => {
                  handleFieldChange(e)
                }}
                name={"city"}
                label={"Город"}
                valid={!error.city}
                touched={touched.city}
                required
                shouldValidate
              />
            </div>
            <div className={classes.form_field}>
              <Input
                value={values.address}
                onChange={(e: React.ChangeEvent) => {
                  handleFieldChange(e)
                }}
                name={"address"}
                label={"Адрес (улица, дом)"}
                valid={!error.address}
                touched={touched.address}
                required
                shouldValidate
              />
            </div>
            <div className={classes.form_field}>
              <Input
                value={values.entrance}
                onChange={(e: React.ChangeEvent) => {
                  handleFieldChange(e)
                }}
                name={"entrance"}
                label={"Подъезд"}
                valid={!error.entrance}
                errorMessage={error.entrance}
                touched={touched.entrance}
              />
            </div>
            <div className={classes.form_field}>
              <Input
                value={values.floor}
                onChange={(e: React.ChangeEvent) => {
                  handleFieldChange(e)
                }}
                name={"floor"}
                label={"Этаж"}
                valid={!error.floor}
                errorMessage={error.floor}
                touched={touched.floor}
              />
            </div>
            <div className={classes.form_field}>
              <Input
                value={values.flat}
                onChange={(e: React.ChangeEvent) => {
                  handleFieldChange(e)
                }}
                name={"flat"}
                label={"Квартира"}
                valid={!error.flat}
                errorMessage={error.flat}
                touched={touched.flat}
              />
            </div>
            <div className={classes.form_field}>
              <Checkbox
                onChange={handleChange}
                name={"lift"}
                text={"Есть лифт"}
                valid={!error.lift}
                checked={values.lift}
              />
            </div>
          </div>
        </div>

        {commonErrorMessage}
      </form>
    </Modal>
  )
}

export default ModalEditMedicalInstitution